module.exports = __webpack_public_path__ + "static/media/cae_background_login.ff6f6bb0.png";